<div fxLayoutAlign="center start" class="form-container">
    <form (submit)="login()" [formGroup]="loginForm">
        <div class="title">Login</div>
        <div *ngIf="error" class="error">Login fehlgeschlagen, bitte überprüfen Sie Ihre Login-Daten.</div>
        <div class="input-group">
            <label for="email">E-Mail Adresse</label><br/>
            <input class="login" id="email" formControlName="email" name="email" type="email"
                   placeholder="E-Mail Adresse eingeben "/>
        </div>
        <div class="input-group">
            <label for="password">Passwort</label><br/>
            <input class="login" id="password" formControlName="password" name="password" type="password"
                   placeholder="Passwort eingeben"/>
            <div class="forget-pw" fxLayoutAlign="end center">
                <div (click)="showPasswordForgotten()" class="text">Passwort vergessen?</div>
            </div>
        </div>
        <div class="action">
            <button>Login</button>
        </div>
    </form>
</div>
